import {XMarkIcon} from '@heroicons/react/24/outline'
import React, {FormEvent, useState} from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {MentorId} from '../../domain/mentor'
import useDeleteMentor from '../../hooks/useDeleteMentor'
import Dialog from '../Dialog'
import Divider from '../Divider'
import FlatButton from '../FlatButton'
import ToggleInput from '../ToggleInput'

type Props = Readonly<{
  id: MentorId
  open: boolean
  onClose: () => void
  onError: (error: Error) => void
  onSuccess: () => void
}>

function DeleteMentorDialog({id, open, onClose, onError, onSuccess}: Props) {
  const intl = useIntl()
  const formId = 'delete-mentor'

  const [deleteOrphanedLearners, setDeleteOrphanedLearners] = useState(false)
  const {busy, deleteMentor} = useDeleteMentor({onSuccess, onError})

  return (
    <Dialog open={open} onClose={onClose}>
      <div className="flex flex-col items-center">
        <div className="-mt-6 mb-6 flex w-full items-center justify-between">
          <Dialog.Title className="typography-headline-4">
            <FormattedMessage id="admin.mentorProfile.deleteMentorDialog.title" />
          </Dialog.Title>
          <button className="-mr-2 -mt-2" type="button" onClick={onClose}>
            <span className="sr-only">
              <FormattedMessage id="general.Close" />
            </span>
            <XMarkIcon aria-hidden className="h-7 w-7" />
          </button>
        </div>
        <form
          aria-label={intl.formatMessage({
            id: 'admin.mentorProfile.deleteMentorDialog.form.label'
          })}
          className="w-full"
          name={formId}
          id={formId}
          noValidate
          onSubmit={(event: FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            deleteMentor(id, deleteOrphanedLearners)
          }}
        >
          <ToggleInput
            checked={deleteOrphanedLearners}
            description="admin.mentorProfile.deleteMentorDialog.form.deleteOrphanedLearnersDescription"
            label="admin.mentorProfile.deleteMentorDialog.form.deleteOrphanedLearnersLabel"
            onChange={setDeleteOrphanedLearners}
          />
          <Divider />
          <div className="mx-auto mt-2 flex w-full justify-end md:mt-4 lg:mt-6">
            <FlatButton
              disabled={busy}
              form={formId}
              type="submit"
              variant="danger"
            >
              <FormattedMessage id="admin.mentorProfile.deleteMentorDialog.deleteThisMentor" />
            </FlatButton>
          </div>
        </form>
      </div>
    </Dialog>
  )
}

export default DeleteMentorDialog
